var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fz-12 yx-color-text-primary"},[_vm._v("\n\t"+_vm._s(_vm._f("formatEmpty")(_vm.row.shopClaimUserName))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }